function LoginForm({ password, setPassword, onLogin, loginError }) {
    return (
        <div className="admin-login">
            <form onSubmit={onLogin} className="admin-login__form card-common">
                <h2>Admin Login</h2>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Parola"
                    autoFocus
                />
                <button type="submit">Autentificare</button>
                {loginError && <p className="error">{loginError}</p>}
            </form>
        </div>
    );
}

export default LoginForm;
